import Header from "../Header";
import Main from "../Main";
import Reason from "../Reason";
import Footer from "../Footer";
import TourSection from "../TourSection";
import CinematicMovie from "../CinematicMovie/CinematicMovie";
import MomentsGallery from "../MomentsGallery/MomentsGallery";
import BottomSection from "../BottomSection/BottomSection";
import BookingGuide from "../BookingGuide/BookingGuide";
import TourPromoMovie from "../TourPromoMovie/TourPromoMovie";
import OceanGuideSearchLinks from "../components/OceanGuideSearchLinks/OceanGuideSearchLinks";

// 再表示するときは true に戻す
const SHOW_TOUR_PROMO_MOVIE = false;

const Top = () => {
  return (
    <>
      <Header />
      <Main />
      {SHOW_TOUR_PROMO_MOVIE && <TourPromoMovie />}
      <TourSection />
      <Reason />
      <MomentsGallery />
      <CinematicMovie />
      <BottomSection />
      <BookingGuide />
      <OceanGuideSearchLinks />
      <Footer />
    </>
  );
};

export default Top;
